import * as React from "react";
import { Component, CSSProperties } from "react";
import { Alert, AlertTitle, Snackbar, Button } from "@mui/material";

interface UnsyncedDataNotificationProps {
    isVisible: boolean;
    unsyncedReadings: number;
    unsyncedPayloads: number;
    onDismiss?: () => void;
}

const alertStyle: CSSProperties = {
    minWidth: "450px",
    maxWidth: "550px"
};

export default class UnsyncedDataNotification extends Component<UnsyncedDataNotificationProps> {
    render() {
        const { isVisible, unsyncedReadings, unsyncedPayloads, onDismiss } = this.props;

        // Show total count as "readings" to keep it simple for users
        const totalUnsynced = unsyncedReadings + unsyncedPayloads;
        const readingsText = totalUnsynced === 1 ? "reading" : "readings";

        return (
            <Snackbar
                open={isVisible}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={null}
            >
                <Alert
                    severity="warning"
                    style={alertStyle}
                >
                    <AlertTitle>Pending Data Upload</AlertTitle>
                    <div>
                        You have {totalUnsynced} {readingsText} waiting to be uploaded.
                        An iDART update cannot complete until this data is synced.
                    </div>
                    <div style={{ marginTop: "8px" }}>
                        Please stay online with a stable connection to allow the sync to complete
                        automatically. This will be checked again on next launch.
                    </div>
                    <div style={{ marginTop: "8px", fontStyle: "italic", fontSize: "0.9em" }}>
                        If this message persists, please contact Inductosense support.
                    </div>
                    {onDismiss && (
                        <div style={{ marginTop: "12px", textAlign: "center" }}>
                            <Button variant="outlined" size="small" onClick={onDismiss}>
                                Dismiss
                            </Button>
                        </div>
                    )}
                </Alert>
            </Snackbar>
        );
    }
}
